import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Card = styled.div`
  background: ${(props) => props.theme.color.light.default};
  border-radius: 10px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.16);
  display: flex;
  justify-content: space-between;
  margin-bottom: 150px;
  margin-top: -50px;
  overflow: hidden;
`;

export const BackgroundWrapper = styled.div`
  width: 50%;
  background: ${(props) => props.theme.color.blue.lightBlue};
  display: flex;
  align-items: flex-end;
  justify-content: center;
  ${mediaQuery('medium')} {
    display: none;
  }
`;

export const BackgroundImg = styled.img`
  width: auto;
  max-width: 80%;
  height: auto;
  padding: 30px;
  padding-bottom: 0;
  ${mediaQuery('max')} {
    max-width: 100%;
  }
`;

export const FormWrapper = styled.div`
  width: 50%;
  padding: 40px;
  ${mediaQuery('medium')} {
    width: 100%;
  }
`;
